import React from 'react';
import './ResourceItem.scss';

const ResourceItem = (props) => (
    
    <a href={props.itemLink} alt='' rel="noopener noreferrer" target='_blank'>
        <div className='resource-item'>
            <h2>{props.title}</h2>
            <p>{props.description}</p>
        </div>
    </a>
)

export default ResourceItem;